import request from "./base";
const path = "/prices";

export default {
  getPrices: function () {
    return request().get(path + "/");
  }
};
